import { render, staticRenderFns } from "./CustomerFileCard.vue?vue&type=template&id=4d43384f"
import script from "./CustomerFileCard.vue?vue&type=script&lang=js"
export * from "./CustomerFileCard.vue?vue&type=script&lang=js"
import style0 from "./CustomerFileCard.vue?vue&type=style&index=0&id=4d43384f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports